@if ($model() != null && $currentUser() != null) {
    <div class="wrapper px-1" [class.min-height-on]="$isLocalLoading()">
        <!-- Loading (fullscreen genérico) -->
        <ngx-spinner name="genericFullscreen" bdColor="#00000099" size="medium" color="#8bc5d9" type="line-scale-pulse-out-rapid" [fullScreen]="true">
            <h5>Processando...</h5>
        </ngx-spinner>

        <!-- Loading (local) -->
        <ngx-spinner name="local" bdColor="#fbfbfb" size="medium" color="#388fad" type="line-scale-pulse-out-rapid" [fullScreen]="false">
            <h6>Processando...</h6>
        </ngx-spinner>

        <!-- Seletor de papéis -->
        @if ($shouldShowPapelSelector()) {
            <papel-selector [_signerId]="$inputData().eDocsData.signerId"
                            [_isReadOnly]="$isReadOnly()"
                            [_papeis]="$papeisSelector()"
                            [_flowObjectType]="FlowObjectType.StartForm"
                            (_signerIdChange)="signerIdChange($event)"
            ></papel-selector>
            <hr />
        }

        <!-- Formio -->
        @if ($isBootstrapFinished()) {
            <div>
                @if ($formSchema() != null) {
                    <formio class="formio"
                            [form]="$formSchema()"
                            [renderOptions]="{ language: 'pt' }"
                            [options]="formioOptions"
                            [readOnly]="$isReadOnly()"
                            [submission]="$inputData()"
                            (change)="saveDraft($event)"
                            (submit)="onSubmit($event)"
                            (formLoad)="onFormLoad($event)"
                    ></formio>
                } @else {
                    <div class="button-container mt-4">
                        <button type="button" class="btn btn-outline-primary" (click)="loadFormData()">Carregar Formulário Respondido</button>
                    </div>
                }
            </div>
        }

        <!-- Descartar rascunho -->
        @if ($hasDraft() && !$isReadOnly()) {
            <button type="button" class="btn btn-outline-secondary clear-draft"
                    matTooltip="Descarta o rascunho salvo previamente para este formulário mantendo-se o conteúdo preenchido no momento"
                    (click)="clearDraft()"
            >
                Descartar rascunho salvo deste formulário
            </button>
        }
    </div>
} @else {
    <div class="wrapper loading">
        <span class="info-font text-highlight p-2">(Carregando...)</span>
    </div>
}
